const initHelpers = {
	html: document.querySelector('html'),
	body: document.querySelector('body'),

	init: function() {
		// Check if touch device for hover functionality
		if (('ontouchstart' in window || navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints) && !('onmousemove' in window)) {
			this.html.classList.add('touch');
		} else {
			this.html.classList.add('no-touch');
		}

		// Add loaded class to html, to enable transitions
		window.addEventListener('load', () => {
			setTimeout(() => {
				this.html.classList.add('loaded');
			}, 10);
		});
		this.detectFocusOnKeyPress();
		this.skipToContent();
	},
	//Detect key press and add class to body
	detectFocusOnKeyPress: function() {
		const activeFocus = 'active-focus';
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Tab') {
				this.body.classList.add(activeFocus);
			}
		});
		document.addEventListener('mousedown', () => {
			if (this.body.classList.contains(activeFocus)) {
				this.body.classList.remove(activeFocus);
			}
		});
	},
	//skip heder and focus on first next link or button
	skipToContent: function() {
		const skipLink = document.querySelector('.skip-link');
		const focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [contenteditable], [type=hidden], iframe:not([tabindex="-1"]), video:not([tabindex="-1"]), audio:not([tabindex="-1"])';
		const focusableElements = document.querySelector('main').querySelector(focusableElementsString);
		skipLink.addEventListener('keyup', (e) => {
			if (e.code === 'Enter' || e.code === 'NumpadEnter') {
				if (!focusableElements) return;
				focusableElements.focus({ preventScroll: false });
			}
		});
	}
};

export default initHelpers;
